import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEventsFormFormBuilderUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'events._base_domain_': [
      {
        srcPath: '',
        destPath: '',
      },
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
    ],
    'www.wixevents.com': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/api',
        destPath: '/api',
      },
      {
        srcPath: '/viewEvent',
        destPath: '/viewEvent',
      },
      {
        srcPath: '/viewRsvpDashboard',
        destPath: '/viewRsvpDashboard',
      },
      {
        srcPath: '/viewOrderDashboard',
        destPath: '/viewOrderDashboard',
      },
      {
        srcPath: '/viewSummarySubscription',
        destPath: '/viewSummarySubscription',
      },
      {
        srcPath: '/check-in',
        destPath: '/check-in',
      },
      {
        srcPath: '/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/export',
        destPath: '/export',
      },
      {
        srcPath: '/tickets',
        destPath: '/tickets',
      },
      {
        srcPath: '/payment-redirect',
        destPath: '/payment-redirect',
      },
      {
        srcPath: '/admin',
        destPath: '/admin',
      },
      {
        srcPath: '/ticket',
        destPath: '/ticket',
      },
      {
        srcPath: '/media',
        destPath: '/media',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/wix-events-web',
        destPath: '',
      },
    ],
    'events.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/events',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wix-events-web',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
      {
        srcPath: '/events/v1/reports',
        destPath: '/v1/reports',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/web',
        destPath: '/v1/web',
      },
      {
        srcPath: '/events/v2/tickets',
        destPath: '/v2/tickets',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
    ],
    'api._base_domain_': [
      {
        srcPath: '/events/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/events/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/events/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/events/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/events/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/events/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    _: [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/events/v2/events',
        destPath: '/v2/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v2',
        destPath: '/v2',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
      {
        srcPath: '/events/v1/bulk/events',
        destPath: '/v1/bulk/events',
      },
    ],
    '*.pub.wix-code.com': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'editor-flow.wixapps.net': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
        destPath: '/v1/bulk-async/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/bulk/categories',
        destPath: '/v1/bulk/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/wix-events-web/v1/events',
        destPath: '/v1/events',
      },
      {
        srcPath: '/_api/wix-events-web/v1/orders',
        destPath: '/v1/orders',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_events_forms';

/** Retrieves an event registration form. */
export function getForm(payload: object): RequestOptionsFactory<any> {
  function __getForm({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'GET' as any,
      methodFqn: 'wix.events.form.FormBuilder.GetForm',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getForm;
}

/** Adds an input control to the form. The applied changes trigger form publishing. */
export function addControl(payload: object): RequestOptionsFactory<any> {
  function __addControl({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'POST' as any,
      methodFqn: 'wix.events.form.FormBuilder.AddControl',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form/control',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __addControl;
}

/** Updates an existing input control in the form. The applied changes trigger form publishing. */
export function updateControl(payload: object): RequestOptionsFactory<any> {
  function __updateControl({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'PUT' as any,
      methodFqn: 'wix.events.form.FormBuilder.UpdateControl',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form/controls/{id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateControl;
}

/** Deletes an input control from the form. The applied changes trigger form publishing. */
export function deleteControl(payload: object): RequestOptionsFactory<any> {
  function __deleteControl({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.form.FormBuilder.DeleteControl',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form/controls/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteControl;
}

/**
 * Updates a set of defined form messages that are displayed to a site visitor before, during, and after the registration flow.
 * Includes the configuration of form titles, response labels, "thank you" messages, and call-to-action texts.
 */
export function updateMessages(payload: object): RequestOptionsFactory<any> {
  function __updateMessages({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fields' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'PATCH' as any,
      methodFqn: 'wix.events.form.FormBuilder.UpdateMessages',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form/messages',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __updateMessages;
}

/**
 * Publishes the draft form.
 * @deprecated Will be removed on 2026-01-05.
 */
export function publishDraft(payload: object): RequestOptionsFactory<any> {
  function __publishDraft({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'POST' as any,
      methodFqn: 'wix.events.form.FormBuilder.PublishDraft',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form/publish',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __publishDraft;
}

/**
 * Clears all changes to the draft form.
 * @deprecated Will be removed on 2026-01-05.
 */
export function discardDraft(payload: object): RequestOptionsFactory<any> {
  function __discardDraft({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.events.v1.form',
      method: 'DELETE' as any,
      methodFqn: 'wix.events.form.FormBuilder.DiscardDraft',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEventsFormFormBuilderUrl({
        protoPath: '/v1/events/{eventId}/form',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __discardDraft;
}
